import React, { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

// Views
import Dashboard from './views/Dashboard';
import Settings from './views/Settings';
import Maintenance from './views/Maintenance'
import SignIn from './views/SignIn';
import EstadoOperativo from './views/ControlOperativo'
import SummaryObjectives from './views/ServiceByObjective'
import UnderDevelopment from './views/UnderDevelopment';
import NotFound from './views/NotFound';
import ManageObjectives from './views/ManageObjective';
import SpecialAccess from './views/SpecialAccess';
import Symbology from './views/Symbology';
//import QuickViewIspView from './views/QuickViewIspView'
import thresholdAvailability from './views/DisponibilidadUmbral';
import QuickViewIspViewLights from './views/QuickViewIspLights';
import Home from './views/Home';
import Support from './views/Support';
import Boards from './views/Boards';
import ComparisonObjectives from './views/ComparisonObjectives';
import Sentimiento from './views/Sentimiento';

// Views Atentus
import Special from './views/Special'
import Online from './views/Online';


//HOCs 

//Autenticación
import authGuard from './HOCs/authGuard'
import { clientAccessHelpers } from './hooks/useClientAccess';
import { Apdex } from './views/Apdex';
import GeneralStatusMain from './views/Dashboard/components/GeneralStatus/GeneralStatusMain';
import ThresholdAvailabilityPlus from './views/DisponibilidadUmbralPlus';
import { PublicFlashboard } from './views/public/Flashboard';
import { HeatMap } from './views/HeatMap';
import { DynamicPanel } from './views/DynamicPanel';
import { Indicadores } from './views/Metricas';
import SyncAvailability from './views/SyncAvailability';

export default class Routes extends Component {
  render() {
    const syncAvailabilityIsEnabled = sessionStorage.getItem('acceso_dashboard_pichincha') === 'true'
    const isMovistarPeruClient = clientAccessHelpers.isMovistarPeruClient()
    return (
      <Switch>
        <Redirect
          exact
          from="/"
          to="/sign-in"
        />
        <Route
          component={authGuard(Home)}
          exact
          path="/home"
        />
        {isMovistarPeruClient ? (
        <Route
          component={authGuard(Sentimiento)}
          exact
          path="/sentimiento"
        />
        ) : null}
        <Route
          component={authGuard(Dashboard)}
          exact
          path="/quickview"
        />
        <Route
          component={authGuard(EstadoOperativo)}
          exact
          path="/estadoOperativo"
        />
        <Route
          component={authGuard(SummaryObjectives)}
          exact
          path="/SummaryObjectives"
        />
        <Route
          component={authGuard(GeneralStatusMain)}
          exact
          path="/generalStatus"
        />
        <Route
          component={authGuard(QuickViewIspViewLights)}
          exact
          path="/quickviewisplights"
        />
        <Route
          component={authGuard(ComparisonObjectives)}
          exact
          path="/comparisonObjectives"
        />
        <Route
          component={authGuard(Online)}
          exact
          path="/online/:objetivo_id/:nombre_objetivo/:nombre_servicio_unificado"
        />
        <Route
          component={authGuard(Special)}
          exact
          path="/especial/:objetivo_id/:nombre_objetivo"
        />
       <Route
          component={authGuard(Support)}
          exact
          path="/support"
        />
        <Route
          component={authGuard(Maintenance)}
          exact
          path="/maintenance"
        />
        <Route
          component={authGuard(Settings)}
          exact
          path="/settings"
        />
        <Route
          component={authGuard(ManageObjectives)}
          exact
          path="/manageObjectives"
        />

        <Route
          component={SignIn}
          exact
          path="/sign-in"
        />
        <Route
          component={UnderDevelopment}
          exact
          path="/under-development"
        />
        <Route
          component={NotFound}
          exact
          path="/not-found"
        />
        <Route
          component={(SpecialAccess)}
          exact
          path="/specialAccess"
        />
        <Route
          component={(Symbology)}
          exact
          path="/simbologia"
        />
        <Route
          component={authGuard(DynamicPanel)}
          exact
          path="/boards"
        />
        <Route
          component={authGuard(Apdex)}
          exact
          path="/apdex"
        />
        <Route
          component={ authGuard(ThresholdAvailabilityPlus) }
          exact
          path="/disponibilidadumbral"
        />
        <Route
          component={PublicFlashboard}
          exact
          path="/public/flashboard"
        />
        <Route
          component={authGuard(HeatMap)}
          exact
          path="/heatmap"
        />
        <Route
          component={authGuard(Indicadores)}
          exact
          path="/metricas"
        />
        {syncAvailabilityIsEnabled ? (
          <Route
            component={authGuard(SyncAvailability)}
            exact
            path="/availability-sync"
          />
        ) : null}
        <Redirect to="/not-found" />
      </Switch>
    );
  }
}
